<template>
  <div class="about-container">
    <v-layout column align-center justify-center>
      <!--<v-layout column align-center justify-center class="white--text">-->
      <div class="about">
        <div class="text-xs-center mb-2">
          <h1 class="juliazhao">Julia Zhao</h1>
          <span>DRE #01411270<br />RE/MAX Elite Realty</span>
        </div>
        <div style="display: block">
          <div class="about-photo">
            <v-avatar size="120">
              <v-img :src="require('@/assets/img/juliazhao.png')"></v-img>
            </v-avatar>
          </div>
          <div class="achievement-education">
            <h4>Ranked #13 in RE/MAX California in 2023</h4>
            <h4>Ranked #41 in RE/MAX Nationwide in 2023</h4>
            <h4>RE/MAX Circle of Legend Reward</h4>
            <h4>Top 1% RE/MAX Worldwide</h4>
            <h4>RE/MAX Lifetime Achievements</h4>
            <h4>Titan Club Award winner (Top 0.5% RE/MAX Nationwide)</h4>
            <h4>Master’s Degree in Computer Science</h4>
            <h4>Master’s Degree in Political Science</h4>
          </div>
        </div>
        <div>
          <div>
            <p>
              Julia Zhao is one of the most trusted and successful real estate
              professionals in the San Gabriel Valley, focusing on serving
              clients in the cities of Alhambra, Arcadia, San Marino, Monterey
              Park, San Gabriel, Temple City, Pasadena, and South Pasadena for
              more than a decade.
            </p>
            <p>
              With advanced education background and broad real estate
              experience, plus English/Chinese bilingual language skills, Julia
              is superb in negotiating on behalf of her clients in selling and
              buying properties.
            </p>
            <p>
              Emphasizing due diligence and communication among involved
              parties, she turns complicated real estate transactions into
              stress free processes and brings satisfactory results to her
              clients.
            </p>
            <p>
              Market sensitivity helps Julia know how to price right for
              properties to sell quickly. With assistance from the team she
              built up for years, she always makes properties attractive to
              receive multiple offers for maximum value.
            </p>
            <p>
              Julia never sees sales and purchases as the end of service. She
              and her team is always a reliable source of post transaction
              assistance. As a service oriented agent, Julia is proud of having
              chance to serve repeating clients.
            </p>
          </div>
          <div class="pt-4 pb-3">
            <div class="text-xs-center juliazhao">Achievements</div>
            <ul>
              <li>Ranked #13 in RE/MAX California in 2023</li>
              <li>Ranked #41 in RE/MAX Nationwide in 2023</li>
              <li>RE/MAX Circle of Legend Reward</li>
              <li>RE/MAX Top 100 US Individual Agent #37 (Jan- August 2017)</li>
              <li>RE/MAX Top 100 US Individual Agent #35 (Jan – March 2016)</li>
              <li>RE/MAX Top 100 US Individual Agent #77 (Jan-May 2015)</li>
              <li>RE/MAX Lifetime Achievement (since 2014)</li>
              <li>
                RE/MAX Titan Club Award (Top .05% of RE/MAX Agents Worldwide
                2016 - 2017 )
              </li>
              <li>
                RE/MAX Chairman Club Award (Top 1% of RE/MAX Agents Worldwide
                2010, 2012 - 2015 & 2018)
              </li>
              <li>
                RE/MAX Platinum Award (Top 2% of RE/MAX Agents Worldwide
                2008-2009 & 2011)
              </li>
              <li>
                L.A. Five Star Real Estate Professional Winner( 2012 - 2018)
              </li>
              <li>
                Nominee for “10 Best” Real Estate Agents in California from
                American Institute of Professionals (2015-2018)
              </li>
            </ul>
          </div>
          <!--<div class="pt-4 pb-3">-->
          <!--<div class="text-xs-center juliazhao">Education</div>-->
          <!--<ul>-->
          <!--<li>Master of Science (Computer Science), Azusa University</li>-->
          <!--<li>Master of Art, (Political Science), Fudan University</li>-->
          <!--<li>Bachelor of Art ( Sociology ), Shanghai Univerisity</li>-->
          <!--</ul>-->
          <!--</div>-->
          <div class="pt-4 pb-5 julia-team">
            <div class="text-xs-center juliazhao">Team</div>
            <v-list two-line>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/diana.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Diana Rios</v-list-item-title>
                  <v-list-item-subtitle>Interior Designer</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/Tiana.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Tiana Vitrano Saran</v-list-item-title>
                  <v-list-item-subtitle>Staging expert</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/Kam.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Kam Saran</v-list-item-title>
                  <v-list-item-subtitle>Staging expert</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-avatar size="80">
                  <img :src="require('@/assets/img/nick.jpg')" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>Nick Li</v-list-item-title>
                  <v-list-item-subtitle>Photographer</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
        </div>
        <!-- <v-divider light></v-divider>
          <div style="max-width:1800px;"><achievements></achievements></div> -->
      </div>
    </v-layout>
    <!--<div v-if="!isMobile" v-bind:class="{'desktop':!isMobile}" style="position: absolute;max-width:400px;top: 2px;"><achievements></achievements></div>-->
  </div>
</template>

<script>
import { mapState } from "vuex";
// import Achievements from '../components/Achievements'

export default {
  name: "about",
  components: {
    // Achievements
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.homeStore.isMobile,
    }),
  },
};
</script>

<style scoped>
@import "about.css";
</style>
